import {
    getUnifiedARSession,
    SessionParameter,
    SessionApiModel,
} from "@auer-steel/Services/AuerUnifiedARSessionSerice";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

type SessionParameterType = {
    onError?: (error: string) => void;
} & SessionParameter &
    HasOnSuccess<SessionParameter>;

type HandlerType = ApiHandler<SessionParameterType, SessionApiModel>;

export const getUnifiedARSessionApi: HandlerType = async (props: any) => {
    props.apiResult = await getUnifiedARSession({customerNumber: props.parameter.customerNumber, callbackURL : props.parameter.callbackURL});
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiParameter);
};

export const chain = [getUnifiedARSessionApi, ExecuteOnSuccessCallback];

const UnifiedARSessionHandler = createHandlerChainRunner(chain, "unifiedARSessionHandler");
export default UnifiedARSessionHandler;